var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[(_vm.requestMilesTableData.length > 0)?_c('div',[_c('h4',{staticClass:"mb-10 cprimary"},[_vm._v("SOLICITAÇÃO")]),_vm._v(" "),_c('a-table',{staticClass:"travel-table last-itens",attrs:{"pagination":false,"data-source":_vm.requestMilesTableData,"columns":[
        {
          title: 'ID Aéreo',
          dataIndex: 'contract_flight_id',
          key: 'contract_flight_id',
        },
        {
          title: 'Cia',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: 'Programa de Milhas',
          dataIndex: 'miles_program',
          key: 'miles_program',
        },
        {
          title: 'Milhas',
          scopedSlots: {
            customRender: 'miles',
          },
        },
        {
          title: 'Valor Vôo (R$)',
          scopedSlots: {
            customRender: 'value',
          },
        },
        {
          title: 'Moeda Taxas',
          scopedSlots: {
            customRender: 'tax_currency',
          },
        },
        {
          title: 'Taxas',
          scopedSlots: {
            customRender: 'taxes',
          },
        },
        {
          title: '',
          align: 'right',
          fixed: 'right',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ]},scopedSlots:_vm._u([{key:"name",fn:function(record){return _c('div',{},[_vm._v("\n        "+_vm._s(_vm.formatInt(record.miles))+"\n      ")])}},{key:"miles",fn:function(record){return _c('div',{},[_vm._v("\n        "+_vm._s(_vm.formatInt(record.miles))+"\n      ")])}},{key:"value",fn:function(record){return _c('div',{},[_vm._v("\n        "+_vm._s(_vm.formatPricePrBr(record.value))+"\n      ")])}},{key:"tax_currency",fn:function(record){return _c('div',{},[_vm._v("\n        "+_vm._s(record.tax_currency)+"\n      ")])}},{key:"taxes",fn:function(record){return _c('div',{},[_vm._v("\n        "+_vm._s(record.taxes)+"\n      ")])}},{key:"action",fn:function(record){return _c('div',{},[(record.status == 'À Solicitar')?_c('a-popconfirm',{attrs:{"ok-text":"Sim","placement":"bottom","cancel-text":"Não"},on:{"confirm":function($event){return _vm.requestMilesCardRow(
              record.contract_flight_id,
              record.contract_airline_id,
              record
            )}}},[_c('template',{slot:"title"},[_vm._v("\n            Tem certeza que deseja solicitar"),_c('br'),_vm._v("\n            as milhas? Esta ação não poderá"),_c('br'),_vm._v("\n            ser cancelada até o retorno "),_c('br'),_vm._v("da sua solicitação.\n          ")]),_vm._v(" "),_c('a-tooltip',{attrs:{"placement":"top","title":"Solicitar milhas"}},[(!_vm.loadingRequest)?_c('a',{staticClass:"ml-5",staticStyle:{"font-size":"16px","color":"red"}},[_c('a',{staticClass:"cgreen",staticStyle:{"font-size":"16px"}},[_c('i',{staticClass:"far fa-caret-square-right"})])]):_c('a',{staticClass:"ml-5"},[_c('a-icon',{attrs:{"type":"loading"}})],1)])],2):_vm._e()],1)}}],null,false,1556132475)})],1):_vm._e(),_vm._v(" "),(_vm.listMilesOrders.length > 0)?_c('div',[_c('h4',{staticClass:"mb-10 cprimary",class:_vm.requestMilesTableData.length > 0 ? 'mt-20' : ''},[_vm._v("\n      PEDIDOS ENVIADOS\n    ")]),_vm._v(" "),_c('a-table',{staticClass:"travel-table last-itens",attrs:{"pagination":false,"data-source":_vm.listMilesOrders,"columns":[
        {
          title: 'ID Pedido',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: 'ID Aéreo',
          dataIndex: 'flight_id',
          key: 'flight_id',
        },
        {
          title: 'Cia',
          scopedSlots: {
            customRender: 'airline',
          },
        },
        {
          title: 'Pgm. Milhas',
          scopedSlots: {
            customRender: 'miles_program',
          },
        },
        {
          title: 'Milhas',
          dataIndex: 'miles_quantity',
          key: 'miles_quantity',
        },
        {
          title: 'Valor ',
          scopedSlots: {
            customRender: 'flight_value',
          },
        },
        {
          title: 'Taxas ',
          scopedSlots: {
            customRender: 'tax_value',
          },
        },
        {
          title: 'ID Cartão',
          scopedSlots: {
            customRender: 'miles_card',
          },
        },

        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
        },
        {
          title: '',
          align: 'right',
          fixed: 'right',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ]},scopedSlots:_vm._u([{key:"airline",fn:function(record){return _c('div',{},[(record.airline.logo)?_c('div',[_c('img',{attrs:{"src":record.airline.logo,"width":"14","alt":"logo"}})]):_vm._e(),_vm._v(" "),(record.airline.logo == '')?_c('div',[_vm._v("\n          "+_vm._s(record.airline.name)+"\n        ")]):_vm._e()])}},{key:"miles_card",fn:function(record){return _c('div',{},[_vm._v("\n        "+_vm._s(record.miles_card ? record.miles_card.id : "")+"\n      ")])}},{key:"miles_program",fn:function(record){return _c('div',{},[_vm._v("\n        "+_vm._s(record.miles_program.name)+"\n      ")])}},{key:"flight_value",fn:function(record){return _c('div',{},[_vm._v("\n        R$ "+_vm._s(record.flight_value)+"\n      ")])}},{key:"tax_value",fn:function(record){return _c('div',{},[_vm._v("\n        R$ "+_vm._s(record.tax_value)+"\n      ")])}},{key:"action",fn:function(record){return _c('div',{},[(record.status == 'Pendente' && _vm.showActions)?_c('div',[_c('a-popconfirm',{attrs:{"ok-text":"Sim","placement":"bottom","cancel-text":"Não"},on:{"confirm":function($event){return _vm.cancelMilesCardEmission(record, 'cancel-miles-order')}}},[_c('template',{slot:"title"},[_vm._v("\n              ATENÇÃO! Se você cancelar a "),_c('br'),_vm._v("emissão das milhas terá de\n              repetir "),_c('br'),_vm._v("todo o processo novamente. "),_c('br'),_vm._v("Tem certeza que\n              deseja cancelar?\n            ")]),_vm._v(" "),_c('a-tooltip',{attrs:{"placement":"top","title":"Cancelar o pedido"}},[_c('a-button',{staticClass:"red ml-10",staticStyle:{"padding":"0"},attrs:{"loading":_vm.loadingMilesEmissionCancelation,"type":"link"}},[_c('i',{staticClass:"far fa-times-circle"})])],1)],2),_vm._v(" "),_c('a-tooltip',{attrs:{"placement":"top","title":"Aguardando"}},[_c('a',[_c('i',{staticClass:"far fa-clock ml-10",staticStyle:{"color":"#aaa","font-size":"15px","top":"1px","position":"relative"}})])])],1):_vm._e(),_vm._v(" "),(record.status == 'Pendente de Confirmação' && _vm.showActions)?_c('div',[_c('a-popconfirm',{attrs:{"ok-text":"Sim","placement":"bottom","cancel-text":"Não"},on:{"confirm":function($event){return _vm.confirmMilesEmission(record)}}},[_c('template',{slot:"title"},[_vm._v("\n              Ao clicar em CONFIRMAR você completará "),_c('br'),_vm._v("o processo de\n              emissão das milhas. "),_c('br'),_vm._v("Deseja continuar?\n            ")]),_vm._v(" "),_c('a-tooltip',{attrs:{"placement":"top","title":"Confirmar emissão"}},[_c('a-button',{staticClass:"cgreen",staticStyle:{"padding":"0"},attrs:{"type":"link","loading":_vm.loadingMilesEmissionConfirmation}},[_c('i',{staticClass:"far fa-check-circle"})])],1)],2),_vm._v(" "),_c('a-popconfirm',{attrs:{"ok-text":"Sim","placement":"bottom","cancel-text":"Não"},on:{"confirm":function($event){return _vm.cancelMilesCardEmission(record)}}},[_c('template',{slot:"title"},[_vm._v("\n              ATENÇÃO! Se você cancelar a "),_c('br'),_vm._v("emissão das milhas terá de\n              repetir "),_c('br'),_vm._v("todo o processo novamente. "),_c('br'),_vm._v("Tem certeza que\n              deseja cancelar?\n            ")]),_vm._v(" "),_c('a-tooltip',{attrs:{"placement":"top","title":"Cancelar"}},[_c('a-button',{staticClass:"red ml-10",staticStyle:{"padding":"0"},attrs:{"loading":_vm.loadingMilesEmissionCancelation,"type":"link"}},[_c('i',{staticClass:"far fa-times-circle"})])],1)],2),_vm._v(" "),_c('a-tooltip',{attrs:{"placement":"top","title":"Ver o cartão"}},[_c('a',{staticClass:"cgreen ml-10",staticStyle:{"font-size":"14px","position":"relative","top":"2px"},on:{"click":function($event){return _vm.viewMilesCard(record.miles_card.id)}}},[_c('a-icon',{attrs:{"slot":"prefix","type":"eye-svg"},slot:"prefix"})],1)])],1):_vm._e(),_vm._v(" "),(record.status == 'Concluído')?_c('div',[_c('a-tooltip',{attrs:{"placement":"top","title":"Ver o cartão"}},[_c('a',{staticClass:"cgreen ml-10",staticStyle:{"font-size":"14px","position":"relative","top":"2px"},on:{"click":function($event){return _vm.viewMilesCard(record.miles_card.id)}}},[_c('a-icon',{staticStyle:{"zoom":"0.035"},attrs:{"slot":"prefix","type":"eye-svg"},slot:"prefix"})],1)])],1):_vm._e()])}}],null,false,1926616497)})],1):_vm._e(),_vm._v(" "),_c('a-modal',{staticClass:"miles-card-modal",attrs:{"visible":_vm.viewMilesCardDrawer,"footer":false,"width":"1000px"},on:{"cancel":_vm.closeMilesCardDrawer}},[(_vm.viewMilesCardDrawer)?_c('MilesCardsModal',{attrs:{"milesCard":_vm.milesCard,"editMilesCard":_vm.editMilesCard,"editCard":_vm.editCard,"activeMilesCardTab":_vm.activeMilesCardTab,"viewOnly":true},on:{"updateMilesCardsList":_vm.updateMilesCardsList}}):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }